import type { SxProps, Theme } from '@mui/material';

export const ORG_THEMED_TEXT_BUTTON_SX: SxProps<Theme> = {
  alignSelf: 'flex-start',
  border: 'none',
  flexShrink: 0,
  minWidth: 'unset',
  width: 'auto',
};
